import { brandName, faqs, latestFeed } from '@/mocks/homeData';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

const pageJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: brandName,
      description: '聚合网络红人热点事件首发、速递与进展梳理的内容观察平台。',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'Organization',
      name: brandName,
      description: '多源核对与时间线梳理的网络热点内容平台。',
      email: 'tips@heibao-live.example',
    },
    {
      '@type': 'WebPage',
      name: '黑曝现场 | 网红黑曝第一弹 独家速递抢先看',
      description:
        '网红黑曝现场直击,第一弹独家内容持续更新,聚合首发、速递与即时消息,快速掌握最新爆料进展。',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://huichan5.cn/' },
        { '@type': 'ListItem', position: 2, name: '热门爆料', item: 'https://huichan5.cn/#hot' },
      ],
    },
    {
      '@type': 'ItemList',
      name: '最新更新爆料内容',
      itemListElement: latestFeed.slice(0, 8).map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.title,
      })),
    },
  ],
};

export default function SeoHead() {
  return (
    <>
      <title>黑曝现场 | 网红黑曝第一弹 独家速递抢先看</title>
      <meta
        name="description"
        content="黑曝现场聚合网红黑曝首发、独家速递与即时消息,覆盖带货争议、直播圈动态与热点复盘,让你第一时间掌握爆料进展,不错过任何一个关键细节。"
      />
      <meta
        name="keywords"
        content="网红黑曝,网红黑曝现场,网红黑曝第一弹,网红黑曝独家,网红黑曝速递"
      />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href="https://huichan5.cn/" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={brandName} />
      <meta property="og:title" content="黑曝现场 | 网红黑曝第一弹 独家速递抢先看" />
      <meta
        property="og:description"
        content="网红黑曝现场直击,第一弹独家内容持续更新,聚合首发、速递与即时消息。"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="黑曝现场 | 网红黑曝第一弹 独家速递抢先看" />
      <meta
        name="twitter:description"
        content="网红黑曝现场直击,第一弹独家内容持续更新,聚合首发、速递与即时消息。"
      />
      <script type="application/ld+json">{JSON.stringify(pageJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
    </>
  );
}